/*LIBRARY*/
import { Component } from "react";
import ReactDOMServer from "react-dom/server";
import { connect } from "react-redux";
import bbox from "@turf/bbox";

/*COMPONENT*/

/*REDUX*/
import { set_value_insight } from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/
import maplibregl from "maplibre-gl";

const layer_demografi_id = "DEMOGRAFI_INSIGHT";
const layer_poi_id = "POI_INSIGHT";
const layer_grid_line_id = "GRID_INSIGHT_LINE";
const layer_grid_polygon_id = "GRID_INSIGHT_POLYGON"; // New ID for polygon layer

class LAYER_INSIGHT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      last_clicked_q: null, // Track the last clicked "q" property
      last_clicked_r: null, // Track the last clicked "r" property
    };
  }

  componentDidUpdate(prevProps) {
    const basemap_used_after = this.props.properties.basemap_used;
    const basemap_used_before = prevProps.properties.basemap_used;
    if (
      this.props.insight_reducer.insight_update !==
        prevProps.insight_reducer.insight_update ||
      basemap_used_after !== basemap_used_before
    ) {
      this.on_render();
    }
    if (
      this.props.insight_reducer.insight_fly_update !==
      prevProps.insight_reducer.insight_fly_update
    ) {
      this.on_fly_content();
    }

    // Delete all markers when 'is_show_top_result' is set to false
    if (this.props.layer.layer_id !== prevProps.layer.layer_id) {
      this.state.markers.forEach((marker) => {
        marker.remove(); // Remove marker from the map
      });
    }
  }

  on_render = () => {
    const {
      features_poi,
      features_demography,
      features_grid_filtered,
      is_show_top_result,
      features_centroid_sample,
    } = this.props.insight_reducer;
    const { map_object } = this.props.layer;
    if (!map_object) return;

    const geojson_demografi = {
      type: "FeatureCollection",
      features: features_demography,
    };
    const geojson_poi = {
      type: "FeatureCollection",
      features: features_poi,
    };
    const geojson_grid = {
      type: "FeatureCollection",
      features: features_grid_filtered,
    };

    let padding = "4px 8px";
    let margin = "5px auto";
    const font_size = 17;
    const font_weight = 600;
    // const text_stroke_width = 10;
    const text_stroke_color = "#fff";
    const text_color_primary = "#000";

    const style_general = {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 3,
      overflow: "hidden",
      whiteSpace: "normal",
      wordBreak: "break-word",
      textAlign: "center",
      lineHeight: "120%",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      fontSize: `${font_size}px`,
      fontWeight: font_weight,
      padding,
    };

    this.state.markers.forEach((marker) => marker.remove());

    if (is_show_top_result) {
      const newMarkers = [];

      features_centroid_sample.forEach((feature) => {
        let label_final = (
          <div
            style={{
              position: "relative",
              margin: margin,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: text_stroke_color,
              borderRadius: "15px",
              minWidth: "35px",
            }}
          >
            <p
              id="text_inside_marker"
              style={{
                ...style_general,
                zIndex: 2,
                color: text_color_primary,
                position: "relative",
                maxWidth: "100px",
              }}
            >
              {feature?.properties?.index}
            </p>
          </div>
        );

        const markerEl = document.createElement("div");
        markerEl.innerHTML = ReactDOMServer.renderToString(label_final);
        const marker = new maplibregl.Marker({ element: markerEl })
          .setLngLat([
            feature.geometry.coordinates[0],
            feature.geometry.coordinates[1],
          ])
          .addTo(map_object);

        newMarkers.push(marker);
      });

      // Update state with all new markers at once
      this.setState({ markers: newMarkers });
    } else {
      // Set empty markers array when not showing top result
      this.setState({ markers: [] });
    }

    // Add or update source and layer for demographic data
    if (!map_object.getSource(layer_demografi_id)) {
      map_object.addSource(layer_demografi_id, {
        type: "geojson",
        data: geojson_demografi,
      });
    } else {
      map_object.getSource(layer_demografi_id).setData(geojson_demografi);
    }

    if (!map_object.getLayer(layer_demografi_id)) {
      map_object.addLayer({
        id: layer_demografi_id,
        type: "line",
        source: layer_demografi_id,
        paint: {
          "line-color": "#db1f2e",
          "line-width": 1,
        },
        layout: {
          visibility: "visible",
        },
      });
    }

    // Add or update source and layer for POI data
    if (!map_object.getSource(layer_poi_id)) {
      map_object.addSource(layer_poi_id, {
        type: "geojson",
        data: geojson_poi,
      });
    } else {
      map_object.getSource(layer_poi_id).setData(geojson_poi);
    }

    if (!map_object.getLayer(layer_poi_id)) {
      map_object.addLayer({
        id: layer_poi_id,
        type: "circle",
        source: layer_poi_id,
        paint: {
          "circle-color": "#1b629e",
          "circle-radius": 4,
          "circle-stroke-width": 1,
          "circle-stroke-color": "#fff",
        },
        layout: {
          visibility: "visible",
        },
      });
    }

    // Add or update source and layer for grid polygons
    if (!map_object.getSource(layer_grid_polygon_id)) {
      map_object.addSource(layer_grid_polygon_id, {
        type: "geojson",
        data: geojson_grid,
      });
    } else {
      map_object.getSource(layer_grid_polygon_id).setData(geojson_grid);
    }

    if (!map_object.getLayer(layer_grid_polygon_id)) {
      map_object.addLayer({
        id: layer_grid_polygon_id,
        type: "fill",
        source: layer_grid_polygon_id,
        paint: {
          "fill-opacity": 0.6,
          "fill-color": [
            "match",
            ["get", "FINAL_STATUS_SCORE"],
            "Sangat Sesuai",
            "rgb(0,107,61)",
            "Sesuai",
            "rgb(128,181,30)",
            "Cukup Sesuai",
            "rgb(255,255,0)",
            "Tidak Sesuai",
            "rgb(246,137,11)",
            "Sangat Tidak Sesuai",
            "rgb(237,19,22)",
            "#fff",
          ],
        },
        layout: {
          visibility: "visible",
        },
      });
    }

    if (!map_object.getSource(layer_grid_line_id)) {
      map_object.addSource(layer_grid_line_id, {
        type: "geojson",
        data: geojson_grid,
      });
    } else {
      map_object.getSource(layer_grid_line_id).setData(geojson_grid);
    }

    if (!map_object.getLayer(layer_grid_line_id)) {
      map_object.addLayer({
        id: layer_grid_line_id,
        type: "line",
        source: layer_grid_line_id,
        paint: {
          "line-color": "#000",
          "line-width": 1.5,
        },
        layout: {
          visibility: "visible",
        },
      });
    }

    this.generate_pop_up();
  };

  generate_pop_up = () => {
    const click_handler = (event) => {
      const clicked_feature = event?.features?.[0];
      const clicked_q = clicked_feature?.properties?.q;
      const clicked_r = clicked_feature?.properties?.r;

      // Check if the feature has already been clicked based on q and r values
      if (
        this.state.last_clicked_q === clicked_q &&
        this.state.last_clicked_r === clicked_r
      ) {
        return; // Don't trigger the popup again if q and r are the same
      }

      // Update the state with the new q and r values
      this.setState({
        last_clicked_q: clicked_q,
        last_clicked_r: clicked_r,
      });

      this.props.set_value_insight({
        key: "feature_sample",
        value: clicked_feature,
      });
    };

    const map_object_string = this.props.map_object_string || "map_object";
    const map_object = this.props.layer[map_object_string];
    map_object.on("click", layer_grid_polygon_id, click_handler); //for desktop
    map_object.on("touchstart", layer_grid_polygon_id, click_handler); //for touchscreen devices
  };

  on_fly_content = () => {
    const { map_object, is_pause_zoom_map } = this.props.layer;
    if (!is_pause_zoom_map) {
      const { features_demography } = this.props.insight_reducer;
      if (!map_object || features_demography.length === 0) return;
      const geojson_demografi = {
        type: "FeatureCollection",
        features: features_demography,
      };
      const [minLng, minLat, maxLng, maxLat] = bbox(geojson_demografi);

      map_object.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat],
        ],
        {
          padding: this.props.layer.padding_fly,
          maxZoom: this.props.layer.max_zoom,
        },
      );
    }
  };

  render() {
    return <main />;
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  properties: state.properties,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, { set_value_insight })(LAYER_INSIGHT);
